import { canClientBeMessagingRecipient } from '../FirmClient/util';
import { Conversation, ConversationParticipantType, FirmClient } from '../generated/graphql';

export const getParticipantsOfType = (
  conversation: Conversation | undefined | null,
  type: ConversationParticipantType
) => {
  if (!conversation) return [];
  const personParticipants = conversation.participants.filter((p) => p.type === type);
  return personParticipants.length === 0 ? conversation.participants : personParticipants;
};

export const listedParticipantNames = (conversation: Conversation | undefined) => {
  if (!conversation) return '';
  const personParticipants = getParticipantsOfType(conversation, ConversationParticipantType.Person);
  return displayNames(personParticipants.map((p) => p.givenName));
};

export function displayNames(givenNames: string[]) {
  return [[givenNames.slice(0, -1).join(', ')], givenNames.slice(-1)].join(givenNames.length > 1 ? ' & ' : '');
}

export const participantsForFirmClientDisplayNames = (firmClient: FirmClient | undefined | null) => {
  if (!firmClient) return '';

  const { messagingRecipients } = canClientBeMessagingRecipient(firmClient);
  const participantNames = messagingRecipients.map((individual) => individual.givenName || '');

  return displayNames(participantNames);
};
